module.exports = __webpack_public_path__ + "static/img/b4_footer.03ee07b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page/childrens/b4_footer.png
// module id = 1ZUM
// module chunks = 1